export const Grid = ({ children, min = 280 }) => (
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(" + min + "px, 1fr))", gap: 16 }}>{children}</div>
);
